import React from 'react';
import { H5 } from '@finect/tabular-core/Headings';
import { HTML } from '../../../HTML';
import { Inner, StyledArticle } from './partials';
export var Article = function Article(_ref) {
  var article = _ref.article;
  var body = article.body,
    title = article.title;
  return React.createElement(Inner, null, React.createElement(H5, null, title), React.createElement("div", null, React.createElement(HTML, {
    html: body.text,
    wrapper: StyledArticle
  })));
};